<template>
  <v-menu
    v-if="show"
    light
    transition="slide-x-transition"
  >
    <template #activator="{ on, attrs }">
      <slot name="activator" :on="on" :attrs="attrs" />
    </template>
    <v-list dense>
      <v-list-item
        v-for="note in notes"
        :key="note.id"
        @click="select(note)"
      >
        <v-list-item-title>
          <v-icon
            small
            :color="note.color || 'transparent'"
            v-text="icons.dot"
          />
          <span class="ml-1" v-text="note.name"/>
        </v-list-item-title>
        <v-list-item-icon>
          <v-icon
            v-if="note.sent"
            small
            color="success"
            v-text="icons.done"
          />
        </v-list-item-icon>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
  import ComparesVersions from '@/Mixins/ComparesVersions'
  import UsesIcons from '@/Mixins/UsesIcons'

  export default {
    mixins: [
      ComparesVersions,
      UsesIcons,
    ],

    computed: {
      order () {
        return this.$store.state.orders.current
      },
      sentNotes () {
        let notes = this.order.notes_sent
          ?.split(',')
          .map(v => parseInt(v))
          ?? []

        if (! this.canSendHandyActions) {
          notes = notes.map(v => v < 10000 ? v : (v - 10000)) // REV-17762
        }

        return notes.unique()
      },
      notes () {
        const notes = this.$store.getters['rummage/kitchenNotes']
        if (! notes.length) {
          return []
        }

        // from Xef’s APP KitchenNotesController
        const dishOrders = this.order.orderContents
          .map(content => content.dishOrder)
          .unique()

        return notes
          .filter(note => note.dish_order_id === null || dishOrders.includes(
            this.$store.getters['catalog/dishOrder'](note.dish_order_id)?.order ?? 0
          ))
          .map(note => ({
            ...note,
            sent: this.sentNotes.includes(note.id),
          }))
      },
      show () {
        return this.canSendKitchenNotes
            && this.$store.state.workingModes.event === false
            && this.notes.length > 0
      },
    },

    methods: {
      select (note) {
        if (! this.canSendHandyActions) {
          note.id += 10000 // REV-17762
        }
        this.$emit('select', note)
      },
    },
  }
</script>
